import type {
  ReferenceRangeCriticality,
  ReferenceRanges,
} from "@/types/observations";
import type * as fhirTypes from "fhir/r4";

export enum LifestyleQuestionnaireTypes {
  AUDIT_C = "curai-audit-c",
  PSQI = "curai-psqi",
  FTND = "curai-ftnd",
  GLTEQ = "curai-glteq",
  REAP_S = "curai-reap-s",
}

export enum MentalHealthQuestionnaireTypes {
  PHQ_9 = "curai-phq-9",
  PHQ_2 = "curai-phq-9-screener",
  GAD_7 = "curai-gad-7",
  GAD_2 = "curai-gad-7-screener",
}

export type QuestionnaireType =
  | LifestyleQuestionnaireTypes
  | MentalHealthQuestionnaireTypes;

export const VariableLengthQuestionnaireTypes: QuestionnaireType[] = [
  LifestyleQuestionnaireTypes.AUDIT_C,
  LifestyleQuestionnaireTypes.PSQI,
  LifestyleQuestionnaireTypes.FTND,
  MentalHealthQuestionnaireTypes.PHQ_2,
  MentalHealthQuestionnaireTypes.GAD_2,
];

export interface QuestionnaireInfo {
  displayName: string;
  shorthandName: string;
}

export const QUESTIONNAIRE_NAMES: Record<QuestionnaireType, QuestionnaireInfo> =
  {
    [LifestyleQuestionnaireTypes.AUDIT_C]: {
      displayName: "Alcohol",
      shorthandName: "AUDIT-C",
    },
    [LifestyleQuestionnaireTypes.REAP_S]: {
      displayName: "Diet",
      shorthandName: "REAP",
    },
    [LifestyleQuestionnaireTypes.GLTEQ]: {
      displayName: "Physical Activity",
      shorthandName: "GLTEQ",
    },
    [LifestyleQuestionnaireTypes.PSQI]: {
      displayName: "Sleep",
      shorthandName: "PSQI",
    },
    [LifestyleQuestionnaireTypes.FTND]: {
      displayName: "Smoking",
      shorthandName: "FTND",
    },
    [MentalHealthQuestionnaireTypes.PHQ_2]: {
      displayName: "Depression",
      shorthandName: "PHQ-2",
    },
    [MentalHealthQuestionnaireTypes.PHQ_9]: {
      displayName: "Depression",
      shorthandName: "PHQ-9",
    },
    [MentalHealthQuestionnaireTypes.GAD_2]: {
      displayName: "Anxiety",
      shorthandName: "GAD-2",
    },
    [MentalHealthQuestionnaireTypes.GAD_7]: {
      displayName: "Anxiety",
      shorthandName: "GAD-7",
    },
  };

export enum QuestionnaireLifeCycleStatus {
  SENT = "sent",
  IN_PROGRESS = "in-progress",
  COMPLETED = "completed",
}

export interface QuestionnaireResponseBase {
  questionnaireId: LifestyleQuestionnaireTypes | MentalHealthQuestionnaireTypes;
  questionnaireResponse: fhirTypes.QuestionnaireResponse | null;
  responseScore: number | null;
  maxScore: number | null;
  questionCount: number;
  questionnaireShortLabel: string;
  questionnaireName: string;
}

export interface QuestionnaireResponseData extends QuestionnaireResponseBase {
  questionnaireSentDatetime?: string | null;
  questionnaireLifecycleStatus?: QuestionnaireLifeCycleStatus | null;
  questionnaireStatusTransitionDatetime?: string | null;
  criticality?: ReferenceRangeCriticality | null;
  referenceRanges?: ReferenceRanges | null;
}
